import { render, staticRenderFns } from "./ClassesList.vue?vue&type=template&id=6adbf1bd&scoped=true&"
import script from "./ClassesList.vue?vue&type=script&lang=js&"
export * from "./ClassesList.vue?vue&type=script&lang=js&"
import style0 from "./ClassesList.vue?vue&type=style&index=0&id=6adbf1bd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6adbf1bd",
  null
  
)

export default component.exports